import { useCallback } from 'react';

import { useFormLanguage } from '@app/hooks/useFormLanguage';
import { useLogoImage } from '@app/hooks/useLogoImage';
import {
  conditionalFields,
  formFields,
  nonRequiredFields,
  transformQuestionWithCallback,
} from '@app/utils/questionUtils';
import { validateConditionalFields, validateFormFields } from '@app/utils/validateUtils';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import CreateView from '@app/components/common/views/CreateView';

import { QuestionForm } from './QuestionForm';

export const CreateQuestion = () => {
  const { transform: logoTransform } = useLogoImage(nonRequiredFields);
  const { language } = useFormLanguage();

  /**
   * Workaround to turn the responses into the format the API expects
   * TODO will need to make sure this works for multilingual payloads
   */
  const questionTransform = (values: GenericObject) => {
    return transformQuestionWithCallback(values, logoTransform, language);
  };

  const validate = useCallback((values: GenericObject) => {
    const errors = validateFormFields({ fields: formFields, values });
    const conditionalFieldsErrors = validateConditionalFields({ fields: conditionalFields, values });
    return { ...errors, ...conditionalFieldsErrors };
  }, []);

  return (
    <CreateView transform={questionTransform} resourceSingular="question" validate={validate}>
      <QuestionForm title="CREATE QUESTION" />
    </CreateView>
  );
};
